export default [
    {
        path: '/dossier/survey',
        props: true,
        component: () => import('@/views/Dossier/Survey'),
    },
    {
        path: '/dossier/survey/:id/results',
        props: true,
        component: () => import('@/views/Dossier/Survey/Results'),
    },
    {
        path: '/dossier/survey/:surveyId/results/:id',
        props: true,
        component: () => import('@/views/Dossier/Survey/Results/Show'),
    },
];